module.exports = __webpack_public_path__ + "img/welcomes-preview-bag-fanli.26de0fc0.png";